module.exports = "/_next/static/images/GregMaes-d0e58c2bb516088155336283de052686.webp";